import * as Yup from 'yup';

export const insuredsDetailsValidationSchema = (
  _isEndorsement?: boolean,
  _amendmentType?: string
) => {
  return Yup.object().shape({
    insuredPolicyMedicals: Yup.array().of(
      Yup.object().shape({
        netPremiumVariance: Yup.number()
          .typeError('Required')
          .required('Required')
          .when('netPremium', ([netPremium], schema) => {
            console.log(netPremium, schema, 'HELLO');

            return schema
              .min(-(netPremium ?? 0), 'Invalid Value')
              .max(0, 'Invalid Value');
          }),
        tpaFeesVariance: Yup.number()
          .typeError('Required')
          .required('Required')
          .when('tpaFees', ([tpaFees], schema) => {
            return schema
              .min(-(tpaFees ?? 0), 'Invalid Value')
              .max(0, 'Invalid Value');
          }),
        chargesVariance: Yup.number()
          .typeError('Required')
          .required('Required')
          .when('charges', ([charges], schema) => {
            return schema
              .min(-(charges ?? 0), 'Invalid Value')
              .max(0, 'Invalid Value');
          })
      })
    )
  });
};
